import { slugWomen, slugMen, slugKids } from "const/genderSlugs";
import { ShopType as ShopTypeGQLEnum } from "src/types/graphql.d";

export enum ShopType {
  Women = "women",
  Men = "men",
  Kids = "kids",
  All = "all",
}

// product.gender is returned from gql in the language of the product
// it should be returned in english
type Props = {
  gender?: string | null;
};

export function localeFix({ gender }: Props): ShopTypeGQLEnum {
  if (!gender) return ShopTypeGQLEnum.Women;

  const genderToLower = gender && gender.toLowerCase();

  if (slugWomen.includes(genderToLower)) return ShopTypeGQLEnum.Women;
  if (slugMen.includes(genderToLower)) return ShopTypeGQLEnum.Men;
  if (slugKids.includes(genderToLower)) return ShopTypeGQLEnum.Kids;

  return ShopTypeGQLEnum.Women;
}

export function localeFixOptional({
  gender,
}: Props): ShopTypeGQLEnum | undefined {
  if (!gender || gender === ShopType.All) return undefined;

  const genderToLower = gender.toLowerCase();

  if (slugWomen.includes(genderToLower)) return ShopTypeGQLEnum.Women;
  if (slugMen.includes(genderToLower)) return ShopTypeGQLEnum.Men;
  if (slugKids.includes(genderToLower)) return ShopTypeGQLEnum.Kids;

  return undefined;
}

export function isGender(gender: string): boolean {
  return [...slugWomen, ...slugMen, ...slugKids].includes(gender);
}

export function localeFixToNl({ gender }: { gender: string }): string {
  if (slugWomen.includes(gender)) return "dames";
  if (slugMen.includes(gender)) return "heren";
  if (slugKids.includes(gender)) return "kids";
  return "dames";
}
